import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PortfolioAuthContext = createContext(null);

export const usePortfolioAuth = () => {
  const context = useContext(PortfolioAuthContext);
  if (!context) {
    throw new Error('usePortfolioAuth must be used within PortfolioAuthProvider');
  }
  return context;
};

export const PortfolioAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);

  useEffect(() => {
    // Check for existing session on mount
    checkAuth();
  }, []);

  const checkAuth = () => {
    try {
      const storedToken = localStorage.getItem('portfolio_token');
      const storedUser = localStorage.getItem('portfolio_user');
      
      if (storedToken && storedUser) {
        setToken(storedToken);
        setUser(JSON.parse(storedUser));
      }
    } catch (error) {
      console.error('Error checking auth:', error);
      // Clear invalid data
      localStorage.removeItem('portfolio_token');
      localStorage.removeItem('portfolio_user');
    } finally {
      setLoading(false);
    }
  };

  const login = (tokenData, userData) => {
    localStorage.setItem('portfolio_token', tokenData);
    localStorage.setItem('portfolio_user', JSON.stringify(userData));
    setToken(tokenData);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('portfolio_token');
    localStorage.removeItem('portfolio_user');
    setToken(null);
    setUser(null);
  };

  const isAuthenticated = () => {
    return !!token && !!user;
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    isAuthenticated,
    checkAuth
  };

  return (
    <PortfolioAuthContext.Provider value={value}>
      {children}
    </PortfolioAuthContext.Provider>
  );
};
